<template>
    <div>
        <label v-if="label" class="w-full block text-gray-700">{{ label }}</label>
        <div class="flex">
            <button v-for="opt, i in opts"  :key="opt.value"
                @click.prevent="selectOption(opt.value)"
                :class="[ classes[buttonStyle].base, indexClass(i), selectedClass(opt.value) ]"
            >{{ opt.label }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: Object,
            default: String,
            buttonStyle: {
                type: String,
                default: 'pills',
            },
            label: String,
            modelValue: String,
        },
        data() {
            return {
                selected: null,
                classes: {
                    buttonGroup: {
                        base: 'relative border-t border-l border-b px-4 py-2 font-bold border-blue-400 hover:bg-blue-400 hover:text-blue-100 cursor-pointer focus:outline-none transition duration-200 ease-in-out',
                        first: 'rounded-r-none rounded',
                        last: 'rounded-l-none rounded border-r',
                        selected: 'bg-blue-400 text-blue-100',
                        notSelected: 'bg-blue-100 text-blue-400',
                    },
                    pills: {
                        base: 'px-3 py-1 mr-1 font-bold border border-blue-400 rounded-3xl leading-tight focus:outline-none',
                        first: '',
                        last: '',
                        selected: 'bg-blue-400 text-blue-100',
                        notSelected: 'bg-blue-100 text-blue-400',
                    }
                }
            }
        },
        computed: {
            opts() {
                let opts = [];

                Object.keys(this.options).forEach(optKey => {
                    opts.push({
                        value: optKey,
                        label: this.options[optKey],
                    });
                });

                return opts;
            },
            value() {
                return this.modelValue;
            }
        },
        methods: {
            selectOption(optionValue) {
                this.selected = optionValue;
                this.$emit('update:modelValue', this.selected);
                this.$emit('resetValue');
            },
            indexClass(i) {
                if (i === 0) {
                    return this.classes[this.buttonStyle].first;
                } else if (i === this.opts.length - 1) {
                    return this.classes[this.buttonStyle].last;
                } else {
                    return '';
                }
            },
            selectedClass(opt) {
                return opt === this.selected ?
                    this.classes[this.buttonStyle].selected :
                    this.classes[this.buttonStyle].notSelected;
            }
        },
        mounted() {
            if (this.default) {
                this.selectOption(this.default);
            }
        },
        watch: {
            value() {
                this.selectOption(this.value);
            }
        }
    }
</script>
